export class LimitsSettings {
  userName: String;
  dailyMax: String;
  weeklyMax: String;

}
